import { AssetClassValueObjectDTO } from '@core/dto/asset-class-value-object.dto';
import { Model, Serializer } from '@junte/serialize-ts';

import { ValueObject } from './value-object.model';

export class AssetClassValueObjectSerializer implements Serializer<AssetClassValueObject> {
  public deserialize(dto: AssetClassValueObjectDTO): AssetClassValueObject {
    return AssetClassValueObject.create({
      codename: dto.codename,
      name: dto.name || dto.codename, // Fallback to key if no name provided
      parent: dto.assetClass ?? null,
    });
  }

  public serialize(model: AssetClassValueObject): AssetClassValueObjectDTO {
    return {
      assetClass: model.parent,
      codename: model.codename,
      name: model.name,
    };
  }
}

@Model(new AssetClassValueObjectSerializer())
export class AssetClassValueObject extends ValueObject {
  public parent: string = null;

  public static create(data: Partial<AssetClassValueObject>): AssetClassValueObject {
    return Object.assign(new AssetClassValueObject(), data);
  }
}
